export default __webpack_public_path__ + "static/closet-d917964afe7ac0e4de05e16edde50c73.gif";